module.exports = require("@ember/service");